module.exports = __webpack_public_path__ + "img/loading_policy.3c1f3352.svg";